import NewsItems from "./news-items";

export default NewsItems;
